import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';

const ComingSoon = () => {
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={12} textAlign="center" padding>
        <Typography variant="h4">Coming Soon</Typography>
      </Grid>
      <Grid item xs={12} padding>
        <Skeleton width={'100%'} height={300} variant="rectangular" />
      </Grid>
    </Grid>
  );
};
export default ComingSoon;
